module.exports = __webpack_public_path__ + "img/7_123.f24642b6.png";